/* eslint-disable */
import React, { useEffect } from "react";

// css
import "./App.scss";
import "../i18n";

// redux
import { connect, useDispatch, useSelector } from "react-redux";
import { clearMessage } from "_redux/actions/authAction";

// library
import styled from "styled-components";
import { Redirect, Route, Switch, useLocation, useHistory } from "react-router-dom";
import PropTypes from "prop-types";

// component
import Layout from "layout/v1";
import LayoutV2 from "layout/v2";
import LayoutV3 from "layout/v3";
import ProfileLayout from "layout/profile";
import AuthRoute from "../containers/AuthPage";
import Error404Page from "../containers/Error404Page";
import APIDocumentationRoute from "../containers/APIDocumentation";
import MyApplicationPage from "containers/MyApplicationPage";
import UserProfilePage from "../containers/UserProfilePage";

// Routing
import { routes } from "./Routes";

// servicess
import authSvc from "services/authSvc";
import DashboardRoute from "./DashboardRoute";
import ProtectedRoutes from "./ProtectedRoutes";

const AppWrapper = styled.div`
  flex: 1;
`;


function App(props) {
  const { isLogin } = props;
  const location = useLocation();
  const history = useHistory();

  // function resolveAuth(){
  //      if (location.pathname.includes("reset"))
  //      return '/auth/reset-password';
  //      console.log('jalan satu');
  //      return true;
 
  // };
  
  useEffect(() => {
    const urlParams = window.location.href;
    const user = authSvc.currentUser();

    if(!user && !urlParams.includes("auth/reset-password")) {
      history.push('/auth/login')
    }
 
    // replace console.* for disable log on production
    if (localStorage.getItem('current_set') !== 'staging') {
      console.log = () => {}
      console.error = () => {}
      console.debug = () => {}
    }
    if (
      urlParams.includes("staging") ||
      urlParams.includes("qa-") ||
      urlParams.includes("localhost")
    ) {
      localStorage.setItem("current_set", "staging");
    }
  }, [])

  return (
    <AppWrapper>
      <Switch>
        <Route path={"/auth"} component={AuthRoute}>
          {!isLogin && location.pathname.includes("reset") && <Redirect to="/auth/reset-password" />}
          <LayoutV2>
            <Route path="/auth" component={AuthRoute} />
          </LayoutV2>
        </Route>
        <Route path="/docs">
          <Layout withSidebar>
            <Switch>
              <Route component={APIDocumentationRoute} />
            </Switch>
          </Layout>
        </Route>
        <Route path="/profile">
          <ProfileLayout>
            <Route path="/profile" component={UserProfilePage} />
          </ProfileLayout>
        </Route>
        <Switch>
          {routes.map((item, index) =>{
            let Layout = item.isLayout ? <LayoutV3>{item.component}</LayoutV3> : item.component
            return <Route path={item.path} exact={item.exact}>
              <ProtectedRoutes>{Layout}</ProtectedRoutes>
            </Route>
          })}
                  
          {/* <Route path="/404" />  */}
        </Switch>
        <Route>
        <LayoutV3>
          <Route component={Error404Page} />
        </LayoutV3>
      </Route>
      </Switch>
    </AppWrapper>
  );
}

App.propTypes = {
  isLogin: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  isLogin: state.auth.isLoggedIn,
});

export default connect(mapStateToProps, null)(App);
